import React, { Suspense } from 'react';
import styles from './index.scss';
const PageLoading = () => React.createElement("div", { className: styles.pageLoading });
const loadableComponent = (LazyComponent) => {
    // eslint-disable-next-line react/display-name
    return (props) => (React.createElement(Suspense, { fallback: React.createElement(PageLoading, null) },
        React.createElement(LazyComponent, { props: props })));
};
export default loadableComponent;
